export default __webpack_public_path__ + "static/assets/497ac9f04f5ef248e65c952ffaa364e0.svg";